import React, { useContext } from 'react';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import DataExport from './DataExport';
import { NotificationContext } from '../../components/GrowlNotifications';
import { AccountContext } from '../../components/AccountContext';
import { Loading } from '../../components/Loading';
import { getEntityListWithAccount } from '../../utils/AppUtil';

const CONFIG_QUERY = gql`
  query($accountId: ID!, $first: Int) {
    account(id: $accountId) {
      id
      assessmentTemplates(first: $first) {
        edges {
          node {
            id
            title
          }
        }
      }
      accountHierarchy {
        descendantId
        descendantBrandDisplayName
      }
    }
  }
`;

const DataExportContainer = () => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const variables = {
    accountId: currentAccount,
    first: 1000,
  };

  const { data, loading, error } = useQuery(CONFIG_QUERY, {
    variables,
  });

  if (loading) {
    return <Loading id={currentAccount} />;
  }

  if (error) {
    growl.show(error);
    return `Error: ${error}`;
  }

  const { account } = data;

  const templates = getEntityListWithAccount(account, 'assessmentTemplates');
  const accountHierarchy = account.accountHierarchy;

  return <DataExport templates={templates} accountHierarchy={accountHierarchy} />;
};

export default DataExportContainer;
